import login from './login'
import findPwd from './find-pwd'

const custom = {
  path: '',
  component: resolve => require(['../../pages/custom'], resolve),
  children: [
    login,
    findPwd
  ]
}

export default custom



// WEBPACK FOOTER //
// ./src/router/custom/index.js